<template>
  <div>
    <div
      style="
        display: flex;
        padding-left: 5px;
        padding-right: 5px;
        margin-bottom: 5px;
        align-items: center;
      "
    >
      <span style="flex-grow: 1; font-size: 13px">Background Blob</span>
      <v-menu
        :offset-y="true"
        transition="slide-y-transition"
        max-width="320px"
        :close-on-content-click="false"
        v-model="showMenu"
      >
        <template v-slot:activator="{ on }">
          <div
            style="height: 35px; width: 35px; cursor: pointer"
            v-on="on"
            @click="showMenu = true"
            :style="toCssBg({ value: block.config.style.background.blob })"
          >
            &nbsp;
          </div>
        </template>
        <v-card elevation="0">
          <div style="display: flex; flex-wrap: wrap" class="pa-2">
            <div v-for="(p, index) in blobs" :key="index">
              <div
                class="pa-1"
                :style="{
                  border:
                    '1px solid ' +
                    (block.config.style.background.blob === p.value
                      ? '#292961'
                      : 'transparent'),
                }"
              >
                <div
                  style="height: 50px; width: 50px; cursor: pointer"
                  :style="toCssBg(p)"
                  @click="onBlobSelect(p)"
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="pa-2">
            <span class="ml-1">Blob Size</span>
            <div style="display: flex; justify-content: center">
              <div
                class="blob-size"
                :class="{
                  active: block.config.style.background.blobSize == 'cover',
                }"
                @click="block.config.style.background.blobSize = 'cover'"
              >
                Cover
              </div>
              <div
                class="blob-size"
                :class="{
                  active: block.config.style.background.blobSize == 'contain',
                }"
                @click="block.config.style.background.blobSize = 'contain'"
              >
                Contain
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div
            class="pa-2"
            v-if="block.config.style.background.blobSize == 'contain'"
          >
            <span class="ml-1">Position</span>
            <div style="display: flex; justify-content: center">
              <div
                class="blob-size"
                :class="{
                  active: block.config.style.background.blobPosition == 'left',
                }"
                @click="block.config.style.background.blobPosition = 'left'"
              >
                Left
              </div>
              <div
                class="blob-size"
                :class="{
                  active:
                    block.config.style.background.blobPosition == 'center',
                }"
                @click="block.config.style.background.blobPosition = 'center'"
              >
                Center
              </div>
              <div
                class="blob-size"
                :class="{
                  active: block.config.style.background.blobPosition == 'right',
                }"
                @click="block.config.style.background.blobPosition = 'right'"
              >
                Right
              </div>
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
import projectMixin from "./../project-mixin";

export default {
  props: ["block"],
  mixins: [projectMixin],
  data() {
    return {
      showMenu: false,
      blobs: [
        {
          value: "",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob1.svg",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob2.svg",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob3.svg",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob4.svg",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob5.svg",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob6.svg",
        },
        {
          value: "https://cdn.landly.page/images/blobs/blob7.svg",
        },
      ],
    };
  },
  methods: {
    toCssBg(p) {
      return {
        "background-image": "url('" + p.value + "')",
        "background-color": "#4a5b6d",
        border:
          this.block.config.style.background.blob == p.value
            ? "1px solid #292961"
            : "none",
      };
    },
    onBlobSelect(p) {
      this.block.config.style.background.blob = p.value;
      this.saveBlockConfig(this.block);
    },
  },
};
</script>

<style scoped>
.blob-size {
  cursor: pointer;
  transition: 200ms all;
  width: 100%;
  text-align: center;
  border: 1px solid transparent;
}
.blob-size:hover {
  background-color: #efefef;
}
.blob-size.active {
  border: 1px solid #292961;
}
</style>